import { render, staticRenderFns } from "./AddExtraInfo.vue?vue&type=template&id=07bf68ac"
import script from "./AddExtraInfo.vue?vue&type=script&lang=js"
export * from "./AddExtraInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports